import Payment from './Payment';

export default class LineItemPayment {
  fields = {
    payment: {
      value: null
    },
    reversal_entry_id: {
      value: null
    }
  };

  static createFromQueryValues(values) {
    const lineItemPayment = new this();

    for (let field in lineItemPayment.fields) {
      if (values.hasOwnProperty(field)) {
        switch (field) {
          case 'payment':
            lineItemPayment.fields[field].value = (values[field] === null) ?
              values[field] :
              Payment.createFromQueryValues(values[field]);
            break;
          default:
            lineItemPayment.fields[field].value = values[field];
        }
      }
    }

    return lineItemPayment;
  }

  get paymentId() {
    const payment = this.fields.payment.value;
    return payment && payment.fields.id.value;
  }
}